import { z } from 'zod'
import { Model } from './architecture'
import { Rating } from './Rating'

export const ListOfRatingValidation = z.object({
  list: z.instanceof(Rating, { message: '[ListOfRating] list is required' }).array(),
})

export class ListOfRating extends Model {
  static create({ list }: z.infer<typeof ListOfRatingValidation>) {
    ListOfRatingValidation.parse({ list })
    return new ListOfRating(list)
  }

  static fromPrimitives({ ratings }: { ratings?: string[] | number[] }) {
    return ListOfRating.create({
      list: ratings?.map(r => Rating.create({ value: parseInt(r.toString()) })) ?? [],
    })
  }

  static fromJSON({ json }: { json: ReturnType<ListOfRating['toJSON']> }) {
    return ListOfRating.create({
      list: json.list
        .map(ratingJson => Rating.createOrNull({ value: ratingJson.value }))
        .filter(Boolean) as Rating[],
    })
  }

  constructor(private readonly _list: Rating[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  map<T>(fn: (rating: Rating) => T) {
    return this._list.map(fn)
  }
}
